// Lead-capture flag — set once any form is successfully submitted OR the
// husky mascot's CTA is clicked. The HuskyHeroMascot reads this flag to
// suppress further appearances. We use localStorage so the flag persists
// across pages, but expire it after 30 days so returning visitors who
// browse fresh sessions still get the prompt.
//
// Event name: 'ac:lead-captured' is dispatched on window for any other
// component that needs to react.

const KEY = "ac_lead_captured_at";
const TTL_DAYS = 30;

export function markLeadCaptured(reason = "form") {
  try {
    localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), reason }));
    window.dispatchEvent(new CustomEvent("ac:lead-captured", { detail: { reason } }));
  } catch (_) {
    /* localStorage unavailable (private mode) — silently ignore */
  }
}

export function hasLeadBeenCaptured() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const { at } = JSON.parse(raw);
    if (typeof at !== "number") return false;
    const ageMs = Date.now() - at;
    if (ageMs > TTL_DAYS * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(KEY);
      return false;
    }
    return true;
  } catch (_) {
    return false;
  }
}
